import { categoryNames } from 'components/common/JobProfileWidget/text'
import { getLanguages } from 'utils/languages'

export const COMPETENCIES_FIELD = 'competencies'
export const TEMPLATE_LANGUAGE_FIELD = 'language'
export const TEMPLATE_NAME_FIELD = 'name'
export const DEPARTMENT_FIELD = 'department'

export const getFields = () =>
  Object.keys(categoryNames())
    .sort()
    .map(name => ({ [name]: false, name }))

export const getDefaultValues = () => ({
  [TEMPLATE_NAME_FIELD]: '',
  [DEPARTMENT_FIELD]: null,
  [TEMPLATE_LANGUAGE_FIELD]: getLanguages()[1],
  [COMPETENCIES_FIELD]: getFields(),
})

export const getDefaultValuesWithSkills = skills => ({
  ...getDefaultValues(),
  [COMPETENCIES_FIELD]: getFields().map(({ name, ...rest }) => ({
    ...rest,
    name,
    [name]: skills[name] ?? false,
  })),
})
